export interface IRatingHistory {
  program: string | null;
  name: string | null;
  action: string | null;
  author: string | null;
  date: string | null;
  comments: string | null;
}

export class RatingHistory implements IRatingHistory {
  program;
  name;
  action;
  author;
  date;
  comments;

  constructor(config: IRatingHistory) {
    this.program = config.program;
    this.name = config.name;
    this.action = config.action;
    this.author = config.author;
    this.date = config.date;
    this.comments = config.comments;
  }
}
